import React, { PureComponent } from 'react';
import { Record, StoryType } from '~/MedicinalBrandsAnalytics/VirtualBrand/History';

import styles from './styles.less';

interface Props {
	record: Record;
	styles: {
		priceChangeIcon: string;
		packagePriceIntroducedIcon: string;
		brandPriceIntroducedIcon: string;
		eaMahRegistrationIcon: string;
	};
}

export default class HistoryIcon extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { record, styles } = this.props;

		switch (record.storyType) {
			case StoryType.priceChange:
				return <div className={styles.priceChangeIcon} />;

			case StoryType.packagePriceIntroduced:
				return <div className={styles.packagePriceIntroducedIcon} />;

			case StoryType.brandPriceIntroduced:
				return <div className={styles.brandPriceIntroducedIcon} />;

			case StoryType.eaMahRegistration:
				return <div className={styles.eaMahRegistrationIcon} />;

			default:
				return null;
		}
	}
}
